import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=80f5567e&scoped=true&"
import script from "./Business.vue?vue&type=script&lang=js&"
export * from "./Business.vue?vue&type=script&lang=js&"
import style0 from "./Business.vue?vue&type=style&index=0&id=80f5567e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f5567e",
  null
  
)

export default component.exports